var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("label " + _vm.type)},[_c('p',{staticClass:"cap w-900"},[_vm._v(" "+_vm._s(_vm.title.toUpperCase())+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }